import { Button } from 'primereact/button'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    height: auto;
    width: 100%;
    min-height: 25rem;
    padding: 10px;
    box-sizing: border-box;
`

export const ContainerSmall = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
    min-height: 25rem;
    padding: 10px;
    box-sizing: border-box;

    @media (max-width: 600px) {
        width: 100%;
    }
`

export const GridContainer = styled.div`
    display: flex;
    max-width: 100%;
    max-height: 100%;
    overflow: scroll;
    border: 1px solid #e2e8f0;
    user-select: none;
    width: 100%;
    height: 100%;
    overflow-x: auto;
    justify-content: center;
    align-items: center;
`

export const GridContainerSmall = styled.div`
    display: flex;
    max-width: 100%;
    max-height: 100%;
    overflow: scroll;
    border: 1px solid #e2e8f0;
    user-select: none;
    height: 100%;
    overflow-x: auto;
    align-items: center;
`

export const GridWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 50vh;
`

export const GridWrapperSmall = styled.div`
    display: flex;
    justify-content: center; /* horizontal centering */
    align-items: center; /* vertical centering */
    height: 30vh;
    margin: 2rem 4rem 1rem;
    flex-direction: column;
`

export const Grid = styled.div.withConfig({
    shouldForwardProp: (prop) => !['rows', 'columns'].includes(prop),
})<{ rows: number; columns: number }>`
    display: grid;
    grid-template-rows: repeat(${(props) => props.rows}, 28px);
    grid-template-columns: repeat(${(props) => props.columns}, 60px);
    justify-items: center;
    align-items: center;
`

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (min-width: 768px) {
        width: 50%;
    }
`

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50rem;

    @media (max-width: 768px) {
        width: 100%;
    }
`

export const ColorCodeContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 0.75rem 1.5rem; // row-gap and column-gap
    align-items: flex-start;
`

export const WrapperRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: center; /* Optional: center the stacked items */
    }
`

export const TitleBox = styled.div`
    width: 360px;
    height: 28px;
    border: 1px solid #e2e8f0;
    background-color: #fff;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
`

export const RadioContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-self: center;
`

interface CellProps {
    highlight?: boolean
}

export const Cell = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'highlight',
})<CellProps>`
    position: relative;
    width: 60px;
    height: 28px;
    border: 1px solid #e2e8f0;
    border-left: ${(props) => (props.highlight ? '3px solid #ba9d31' : '1px solid #e2e8f0')};
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
        width: 20px;
        height: auto;
    }
`

export const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(186, 157, 49, 0.9);
    color: white;
    font-weight: 600;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`

export const RowWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
`

export const RadioWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;

    input[type='radio'] {
        margin: 0;
        cursor: pointer;
        transform: scale(1.2);
    }
`

export const ZoomContainer = styled.div`
    position: relative;
    z-index: 100;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin-top: 1rem;
    align-self: flex-end;

    @media (max-width: 600px) {
        position: static;
        margin-top: 1rem;
        margin-left: 0;
        flex-direction: row;
        justify-content: end;
        gap: 1rem;
        align-self: unset;
    }
`

export const ZoomButton = styled(Button)`
    background-color: #ba9d31;
    color: #fff;
    padding: 10px;
    margin: 5px 0;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: opacity 0.3s ease;
    opacity: 0.75;

    .pi {
        font-weight: 600;
        font-size: 1.2rem;
    }

    &:hover {
        background-color: #8b761b;
    }
`

export const WrapperColumnCode = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
`

export const WrapperRowCode = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap; /* Optional: allows wrapping on smaller screens */
    width: 100%;
    margin-bottom: 1rem;
`
